module.exports = __webpack_public_path__ + "img/beard-happy.1cff7859.svg";